<template>
  <div class="prh-my-course bg-white ">
    <slot></slot>
    <div class="container list" v-if="cardList">
      <van-card v-for="v in cardList"
                :key="v.id" class="course-item course-item-price d-flex card-row"
                @click-thumb="toLink(v)"
      >
        <template #title>
          <p v-if="typeBlock==='zhibo'" class="c-title van-multi-ellipsis--l2" :class="{'mb-20': typeBlock==='zhibo'}">
            {{v.title}}
          </p>
        </template>
        <template #desc>
          <p class="c-desc" v-if="typeBlock == 'zhuanlan'">
            {{v.desc}}
          </p>
        </template>
        <template #thumb class="course-item">
          <img class="w-100" :src="v.image" alt="">
        </template>
        <template #price>
          <div class="">
            <span class="price color-33">¥ {{v.price}}</span>
          </div>
        </template>
        <template #origin-price>
          <div class="">
            <span class="">¥ {{v.oldPrice}}</span>
          </div>
        </template>
        <template #tags v-if="typeBlock === 'zhibo'">
          <router-link :to="{name:'indexCourse', params: {id: v.id}}"
                       class="zb-tag font-11 color-88">
            回看
          </router-link>
        </template>

      </van-card>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {Card} from 'vant';

  Vue.use(Card);

  export default {
    name: "cardComponent",
    props: [
      'typeBlock',
      'cardList'
    ],
    methods: {
      toLink(e) {
        if (this.typeBlock === 'course') {
          this.$router.push('/course/' + e.id)
        } else if (this.typeBlock === 'zhuanlan') {
          this.$router.push('/zhuanlan/' + e.id)
        }

      }
    }
  }
</script>

<style>

  .news-author {
    font-size: .75rem;
    color: #4c4c4c;
  }

  .zl-zj-ava {
    width: 1.1rem;
    height: 1.1rem;
    border-radius: 50%;
  }
  .van-card {
    background-color: white;
  }

  .zl-page {
    padding: 1.25rem 1rem;
    overflow: hidden;
  }

  .zl-page .course-item .van-card__thumb {
    width: 5rem !important;
    overflow: hidden;
    border-radius: .25rem;
  }

  .zl-page .course-item .van-card__bottom {
    display: flex;
    flex-direction: row !important;
    justify-content: space-between !important;
  }

  .zl-page .course-item .desc {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: .9375rem !important;
    color: #4c4c4c !important;
  }

  .zhibo-card .van-card__content {
    padding: 1rem 1rem 1.5rem;
    min-height: 4rem;
  }

  .zhibo-card .zhitong-title {
    font-size: 1rem !important;
    font-weight: 700 !important;
  }

  .zhibo-card .zb-tag {
    border: 1px solid #888888;
    padding: .15625rem 1.375rem;
    position: absolute;
    /*bottom: .91875rem;*/
    border-radius: .78125rem;
    line-height: 1.125rem;
  }

  .colum-card .van-card {
    display: flex;
    flex-direction: column;
  }

  .colum-card .van-card .van-card__footer {
    position: absolute;
    bottom: .5rem;
    left: .5rem;
  }

  .colum-card .van-card .van-card__header {
    width: 100%;
    flex-direction: column !important;
    box-shadow: 0 0 11px #e3e3e3;
    border-radius: .5rem;
    overflow: hidden;
  }

  .colum-card .van-card .van-card__header .title {
    margin-bottom: 1rem;
  }

  .colum-card .van-card .van-card__header .van-card__thumb {
    width: 100%;
    height: 7rem;
    overflow: hidden;
    margin-right: 0;
    background-size: 100% auto;
  }

  .course-item {
    background-color: white;
    padding: 0;
  }

  .zhibo-card .course-item .van-card__thumb img {
    border-top-left-radius: .3125rem;
    border-top-right-radius: .3125rem;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  .prh-my-course .course-item-price .van-card__bottom {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    margin-top: .25rem;
  }

  .course-item .van-card__header {
    width: 100%;
  }
</style>
